import { render, staticRenderFns } from "./SchlPublicHome.vue?vue&type=template&id=6f51362a&scoped=true&"
import script from "./SchlPublicHome.vue?vue&type=script&lang=js&"
export * from "./SchlPublicHome.vue?vue&type=script&lang=js&"
import style0 from "./SchlPublicHome.vue?vue&type=style&index=0&id=6f51362a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f51362a",
  null
  
)

export default component.exports